import { render, staticRenderFns } from "./aboutNewsInfo.vue?vue&type=template&id=08bfc26e&"
import script from "./aboutNewsInfo.vue?vue&type=script&lang=js&"
export * from "./aboutNewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./aboutNewsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports